import Page from "ui/Page";
import Faq from "areas/home/ui/Faq";


export default function FAQ() {
	return (
		<Page maxWidth="lg">
			<Page.Body>
				<Faq />
			</Page.Body>
		</Page>
	);
}